// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".featured-on{margin:0 auto;width:1024px}.featured-on .list-featured ul{display:flex;margin:0 -15px}.featured-on .list-featured ul li{padding:15px}@media only screen and (max-width:900px){.featured-on{padding:0 20px;width:100%}}", ""]);
// Exports
module.exports = exports;
